import { Center, Text } from "@mantine/core";
import React from "react";
import { useTranslation } from "../../hooks/useTranslation";

// Rendered at the /faq index route before any topic/rule is selected.
export const FaqEmptyState: React.FC = () => {
    const { t } = useTranslation();

    return (
        <Center style={{ height: 200 }}>
            <Text c="dimmed">{t("FAQ_EMPTY_STATE", undefined, "Select a topic to get started")}</Text>
        </Center>
    );
};
